import useSidebarStack from '@/common/sidebar/useSidebarStack.ts';
import AnchorButton from '@/common/components/AnchorButton.tsx';
import type {
  SidebarId,
  SidebarParams,
} from '@/common/sidebar/sidebar-registry.tsx';
import type { ReactNode } from 'react';

type SidebarLinkParams<TId extends SidebarId> = {
  id: TId;
  params: SidebarParams<TId>;
  children: ReactNode;
};

export default function SidebarLink<TId extends SidebarId>({
  id,
  params,
  children,
}: SidebarLinkParams<TId>) {
  const sidebarStack = useSidebarStack();

  return (
    <AnchorButton
      onClick={() => {
        sidebarStack.pushItem(id, params);
      }}
    >
      {children}
    </AnchorButton>
  );
}
